import type ConversationItemParts from './schema/ConversationItemParts';
import type ConversationReadingPaneNode from './schema/ConversationReadingPaneNode';
import type MailStore from './schema/MailStore';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

const mailStoreData: MailStore = {
    conversationNodes: new ObservableMap<string, ConversationReadingPaneNode>({}),
    conversations: new ObservableMap<string, ConversationItemParts>({}),
    items: new ObservableMap({}),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (14,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    searchFolderDisplayName: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (18,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    typeOfItemBeingDragged: null,
    triageAnnouncement: {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (23,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        message: null,
        politenessSetting: 'off',
    },
};

export let getStore = createStore<MailStore>('mail', mailStoreData);
const store = getStore();
export default store;
